module.exports = __webpack_public_path__ + "img/pr-12.a182c68a.png";